import axios from 'axios';
import md5 from 'js-md5'
import store from '@/store';
import {parseTime} from '@/utils/index';
import { getToken } from '@/utils/auth';
import { requestStart, requestEnd } from '@/utils/prerender-ready';

// create an axios instance
const service = axios.create({
  baseURL: window['pathConfig'][process.env.NODE_ENV].baseURL, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 120000, // request timeout
  headers: {
    'Content-Type': 'application/json'
  }
});

// request interceptor
service.interceptors.request.use(
  config => {
    // 预渲染就绪判定：请求发出，在途数 +1
    requestStart();
    // do something before request is sent
    if (getToken()) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      config.headers['token'] = getToken();
    }else{
      config.headers['tokenCookie'] = md5(parseTime(new Date(),'{y}{m}{d}{h}{i}')+'song')
    }
    return config;
  },
  error => {
    // do something with request error
    console.log(error); // for debug
    return Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    requestEnd();
    const res = response.data;
    if (res.state === 'success') {
      return res.data;
    } else {
      if (res.state === 'token') {
        res.state = 'error';
        // store.dispatch('user/resetToken').then(() => {
        //   location.reload();
        // });
      }
      // Toast.fail(res.message || 'Error');
      return Promise.reject(new Error(res.message || 'Error'));
    }
  },
  error => {
    // 失败同样要计数归零，否则预渲染会一直等这个请求
    requestEnd();
    console.log('err' + error); // for debug
    // Toast.fail(error.message);
    return Promise.reject(new Error(error.message || 'Error'));
  }
);

export default service;
